export default class GetPerfilesCursos {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute() {
    try {
      const result = await this.#repository.getAllPerfilesCursos()
      return result
    } catch (error) {
      throw error
    }
  }
}
